module.exports = __webpack_public_path__ + "static/img/douyin-qrcode2.e84e8b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/douyin-qrcode2.jpg
// module id = PyuZ
// module chunks = 68